import {useMemo, useState} from "react"
import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {TemplatesAndGuidelinesModel} from "../models/view/templatesAndGuidelinesModel";
import {initialResourceItemCount} from "../utils/helpers";
import {useAppContext} from "./useAppContext";

export const useTemplatesAndGuidelinesQuery = () => {
    const {productId} = useAppContext();
    const {model: {artworkGuidelineType, artworkGuidelineTypeId, media, primaryMedia}} = useProductDetailsQuery();
    const [showCount, setShowCount] = useState<number>(initialResourceItemCount);

    const {
        title,
        href,
        count,
        templates,
        hasTemplates,
    } = useMemo(() => new TemplatesAndGuidelinesModel(productId, artworkGuidelineType, artworkGuidelineTypeId, media, primaryMedia), [artworkGuidelineType, artworkGuidelineTypeId, media, primaryMedia]);

    const hasArtworkInstructions = !!(artworkGuidelineTypeId && artworkGuidelineTypeId != 6);

    return {
        hasArtworkInstructions,
        title,
        href,
        count,
        breakOutEarly: !hasTemplates && !hasArtworkInstructions,
        templates: templates.slice(0, showCount),
        moreToShow: count > showCount,
        showAll: () => setShowCount(count)
    }
}